import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneNumberStepValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }
    const isValid = [1, 2].includes(value);
    // If the first choice is selected then the user can continue to the next step.
    return isValid ? null : { choiceInvalid: true };
  };
}
